import classes from "./Pol.module.css";

import { useContext, useState } from "react";
import LanguageContext from "../../store/language-context";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

function Pol() {
  const currentLanguageCode = i18next.resolvedLanguage

 function PolEl() {
 
  return(
  
    <div><div className={classes.pHead}><div className={classes.pTitle}><h1>Πολιτική Απορρήτου</h1></div></div><div className={classes.pContent}><strong>Ποια προσωπικά μου δεδομένα συλλέγονται και πώς;</strong>
  <p>
  
  Τα προσωπικά δεδομένα τα οποία συλλέγει και επεξεργάζεται ο Δήμος Αποκορώνου είναι μόνο αυτά που είναι απαραίτητα για τον εκάστοτε συγκεκριμένο και σαφώς ορισμένο σκοπό και τη συγκεκριμένη νομική βάση.
  </p>
  <p>
  
  Στο πλαίσιο αυτό, η επεξεργασία που λαμβάνει χώρα αφορά τα προσωπικά δεδομένα που παρέχετε στον Δήμο Αποκορώνου σε πραγματικό διαδραστικό χρόνο, όταν χρησιμοποιείτε τις υπηρεσίες μας, τους επίσημους διαδικτυακούς μας τόπους, για παράδειγμα κάνοντας εγγραφή, όπως:
  </p>
  <p>
  <ul>
     <li>Όνομα</li>
     <li>Επώνυμο</li>
     <li>E-mail</li>
  </ul>
  Σε όσες από τις περιπτώσεις η επεξεργασία θεμελιώνεται στη λήψη συγκατάθεσης, ο Δήμος Αποκορώνου ακολουθεί τις προβλεπόμενες από το Νόμο διαδικασίες για τη λήψη αυτής.
  </p>
  <p>
  
  <strong>Για ποιους σκοπούς γίνεται η επεξεργασία και ποια η νομική της βάση;</strong></p>
  <p>
  </p>
  <p>
  
  Τα προσωπικά δεδομένα συλλέγονται σύμφωνα με τον ΓΚΠΔ και την ισχύουσα νομοθεσία, είτε με την έναρξη της σχέσης σας με τον Οργανισμό είτε και μεταγενέστερα και αποτελούν αντικείμενο επεξεργασίας με νομική βάση:
  </p>
  <p>
  
  Τη συγκατάθεσή σας, όταν απαιτείται
  
  Την εκτέλεση μιας μεταξύ μας σύμβασης
  
  Την εκπλήρωση των νομικών μας υποχρεώσεων
  
  Τη διαφύλαξη ζωτικού συμφέροντος
  
  Την εκπλήρωση καθήκοντος για το δημόσιο συμφέρον
  
  Τη διαφύλαξη έννομου συμφέροντός μας ή τρίτου
  
  Ο Δήμος Αποκορώνου μπορεί να επεξεργαστεί τα προσωπικά σας δεδομένα, για τους ακόλουθους σκοπούς ανά νομική βάση:
  </p>
  <p>
  <ol>
     <li>Με τη συγκατάθεσή σας</li>
  </ol>
  Μεταβίβαση προσωπικών δεδομένων σε τρίτους
  </p>
  <p>
  
  Αποστολή ενημερώσεων
  <ol start="2">
     <li>Για την εκπλήρωση της συμβατικής υποχρέωσης σε περίπτωση σύναψης σύμβασης με τον Δήμο Αποκορώνου ή κατά την προσυμβατική διαδικασία</li>
  </ol>
  Για την επικοινωνία κατά την προσυμβατική διαδικασία ή κατά την εκτέλεση της σύμβασης
  <ol start="3">
     <li>Για την εκπλήρωση των νομικών μας υποχρεώσεων</li>
  </ol>
  Για την εκπλήρωση των υποχρεώσεών μας σύμφωνα με την ισχύουσα νομοθεσία έναντι δημοσίων αρχών και φορέων (Εποπτικές, Ανεξάρτητες, Αστυνομικές, Δικαστικές).
  <ol start="4">
     <li>Για τη διαφύλαξη ζωτικού συμφέροντος σας ή τρίτου</li>
  </ol>
  Σε περίπτωση που κινδυνεύει η ζωή σας ή η ζωή τρίτου
  <ol start="5">
     <li>Για λόγους έννομου συμφέροντός μας, ως:</li>
  </ol>
  Για την ανάπτυξη και βελτίωση των παρεχόμενων υπηρεσιών μας μέσα από τις δραστηριότητες και τα ενδιαφέροντά σας.
  
  Για τη διαχείριση των παραπόνων σας.
  
  Για την προστασία και ασφάλεια των συστημάτων πληροφορικής.
  </p>
  <p>
  
  <strong>Ποιοι είναι οι αποδέκτες των προσωπικών μου δεδομένων;</strong></p>
  <p>
  </p>
  <p>
  
  Πρόσβαση στα προσωπικά σας δεδομένα έχει το προσωπικό του Δήμου Αποκορώνου, στα πλαίσια της εκτέλεσης των καθηκόντων που τους ανέθεσε ο Δήμος Αποκορώνου ως υπεύθυνος επεξεργασίας.
  
  Ο Δήμος Αποκορώνου είναι υποχρεωμένος ή δικαιούται να κοινοποιεί τα προσωπικά σας δεδομένα σε διάφορους τρίτους αποδέκτες όπως:
  
  Δημόσιους φορείς
  
  Ανεξάρτητες αρχές
  
  υπό τον όρο της τήρησης σε κάθε περίπτωση του απορρήτου και του καθήκοντος εμπιστευτικότητας και εχεμύθειας.
  </p>
  <p>
  
  <strong>Πόσο χρόνο διατηρούνται τα δεδομένα μου;</strong></p>
  <p>
  </p>
  <p>
  
  Ο Δήμος Αποκορώνου διατηρεί τα προσωπικά σας δεδομένα μόνον για το διάστημα που απαιτείται για τους σκοπούς της επεξεργασίας. Ωστόσο οφείλει να διατηρεί τα προσωπικά δεδομένα και για χρονικό διάστημα που καθορίζεται από το ισχύον νομικό και κανονιστικό πλαίσιο.
  </p>
  <p>
  
  
  <strong>Τι είναι τα cookies και γιατί τα συλλέγει ο Δήμος Αποκορώνου;</strong></p>
  <p>
  
  Για να διασφαλίσουμε ότι ο ιστότοπός μας λειτουργεί σωστά, ενδέχεται μερικές φορές να αποθηκευτεί ένα μικρό κομμάτι δεδομένων που είναι γνωστό ως cookie στον υπολογιστή ή την κινητή συσκευή σας κατά την επίσκεψη του ιστότοπού μας. Ένα cookie είναι ένα αρχείο κειμένου που αποθηκεύεται από έναν διακομιστή ιστού σε έναν υπολογιστή ή μια κινητή συσκευή. Το περιεχόμενο ενός cookie μπορεί να ανακτηθεί ή να διαβαστεί μόνο από το διακομιστή που δημιουργεί το cookie. Το κείμενο σε ένα cookie αποτελείται συχνά από αναγνωριστικά, ονόματα τοποθεσιών και ορισμένους αριθμούς και χαρακτήρες. Τα cookies είναι μοναδικά για τα προγράμματα περιήγησης ή τις κινητές εφαρμογές που χρησιμοποιείτε και επιτρέπουν στους ιστότοπους να αποθηκεύουν δεδομένα όπως οι προτιμήσεις σας.
  </p>
  <p>
  
  <strong>Πως προστατεύονται τα δεδομένα μου;</strong></p>
  <p>
  </p>
  <p>
  
  Στον Δήμο Αποκορώνου εργαζόμαστε καθημερινά για να εξασφαλίσουμε ότι τα προσωπικά δεδομένα που λαμβάνουμε:
  
  Υποβάλλονται σε σύννομη και θεμιτή επεξεργασία με διαφανή τρόπο σε σχέση με το υποκείμενο των δεδομένων.
  
  Συλλέγονται αποκλειστικά για συγκεκριμένους και νόμιμους σκοπούς.
  
  Είναι επαρκή, σχετίζονται με το σκοπό για τον οποίο τα συλλέγουμε και περιορίζονται στα απαραίτητα.
  
  Είναι ακριβή και ενημερωμένα.
  
  Διατηρούνται αποκλειστικά εντός του καθορισμένου χρονικού πλαισίου και όχι περισσότερο.
  
  Τίθενται σε επεξεργασία με τέτοιο τρόπο ώστε να εξασφαλίζεται η απαραίτητη προστασία τους.
  </p>
  <p>
  
  <strong>Ποια είναι τα δικαιώματά μου;</strong></p>
  <p>
  </p>
  <p>
  
  Ο Δήμος Αποκορώνου δεν επεξεργάζεται με αυτοματοποιημένο τρόπο και δεν δημιουργεί προφίλ για κανένα φυσικό πρόσωπο του οποίου διατηρεί τα προσωπικά δεδομένα
  
  Το υποκείμενο των δεδομένων έχει τα ακόλουθα δικαιώματα:
  
  <strong>Το δικαίωμα πρόσβασης</strong></p>
  <p>
  
  Μπορείτε ανά πάσα στιγμή να ενημερωθείτε από εμάς για τα προσωπικά σας δεδομένα που διατηρούμε, και να έχετε πρόσβαση σε αυτά.
  
  <strong>Το δικαίωμα στη διόρθωση δεδομένων</strong></p>
  <p>
  
  Έχετε τη δυνατότητα να απευθυνθείτε σε εμάς για να διορθώσουμε τα δεδομένα που είναι ανακριβή ή ελλιπή.
  
  <strong>Το «δικαίωμα στη λήθη»</strong></p>
  <p>
  
  Εφόσον δεν μας υποχρεώνει κάποιο νομοθετικό πλαίσιο να διατηρήσουμε τα δεδομένα που διατηρούμε και σχετίζονται με εσάς, μπορείτε να μας ζητήσετε να τα διαγράψουμε.
  
  <strong>Το δικαίωμα στη φορητότητα των δεδομένων</strong></p>
  <p>
  
  Μπορείτε να μας ζητήσετε να διαβιβάσουμε τα δεδομένα σας σε άλλο δημόσιο ή ιδιωτικό φορέα.
  
  <strong>Το δικαίωμα στην εναντίωση και στον περιορισμό της επεξεργασίας</strong>
  
  Σε περίπτωση που διαφωνείτε με τον τρόπο που επεξεργαζόμαστε τα προσωπικά σας δεδομένα μπορείτε να αιτηθείτε τη διακοπή ή τον περιορισμό της επεξεργασίας.
  
  <strong>Το δικαίωμα άρσης συγκατάθεσης</strong></p>
  <p>
  
  Έχετε το δικαίωμα να αποσύρετε τη συγκατάθεσή σας στην επεξεργασία των δεδομένων σας ανά πάσα στιγμή.
  
  Ο Δήμος Αποκορώνου θα καταβάλει κάθε προσπάθεια να απαντήσει στο αίτημα που θα υποβάλλετε χωρίς καθυστέρηση και σε κάθε περίπτωση εντός μηνός από την παραλαβή του. Η εν λόγω προθεσμία παρατείνεται για δύο (2) ακόμα μήνες, εφόσον είναι απαραίτητο λαμβάνοντας υπόψη την πολυπλοκότητα του αιτήματος και το πλήθος των αιτημάτων. Ο Δήμος Αποκορώνου θα σας ενημερώσει για την εν λόγω παράταση εντός μηνός από την παραλαβή του αιτήματος, καθώς και για τους λόγους της καθυστέρησης. Εάν έχετε υποβάλει το αίτημα με ηλεκτρονικά μέσα, η ενημέρωση παρέχεται, εάν είναι δυνατόν, με ηλεκτρονικά μέσα, εκτός εάν εσείς ζητήσετε κάτι διαφορετικό.
  
  Εφόσον ο Δήμος Αποκορώνου ικανοποιήσει αίτημά σας α) για περιορισμό επεξεργασίας των δεδομένων σας ή β) για άρνηση επεξεργασίας των δεδομένων σας ή γ) για διαγραφή των δεδομένων σας από τα αρχεία του οργανισμού και εφόσον αυτά είναι απαραίτητα για την κατάρτιση ή τη συνέχιση και εκτέλεση σύμβασης, τότε αυτό συνεπάγεται αυτοδίκαια είτε την καταγγελία από εσάς της αντίστοιχης σύμβασης ή τη μη δυνατότητα επεξεργασίας του σχετικού σας αιτήματος.
  </p>
  <p>
  
  <strong>Ανάκληση της συγκατάθεσης</strong></p>
  <p>
  
  Έχετε το δικαίωμα να ανακαλέσετε τη συγκατάθεσή σας ανά πάσα στιγμή. Η ανάκληση της συγκατάθεσης σας δε θίγει τη νομιμότητα της επεξεργασίας που βασίστηκε σε αυτή και έγινε πριν της ανάκλησής της.
  </p>
  <p>
  <strong>Cookies</strong></p>
  <p>
  
  Για να διασφαλίσουμε ότι ο ιστότοπός μας και η εφαρμογή για κινητές συσκευές λειτουργούν σωστά, ενδέχεται μερικές φορές να τοποθετήσουμε ένα μικρό κομμάτι δεδομένων που είναι γνωστό ως cookie στον υπολογιστή ή την κινητή συσκευή σας. Ένα cookie είναι ένα αρχείο κειμένου που αποθηκεύεται από έναν διακομιστή ιστού σε έναν υπολογιστή ή μια κινητή συσκευή. Το περιεχόμενο ενός cookie μπορεί να ανακτηθεί ή να διαβαστεί μόνο από το διακομιστή που δημιουργεί το cookie. Το κείμενο σε ένα cookie αποτελείται συχνά από αναγνωριστικά, ονόματα τοποθεσιών και ορισμένους αριθμούς και χαρακτήρες. Τα cookies είναι μοναδικά για τα προγράμματα περιήγησης ή τις κινητές εφαρμογές που χρησιμοποιείτε και επιτρέπουν στους ιστότοπους να αποθηκεύουν δεδομένα όπως οι προτιμήσεις σας.
  </p>
  <p>
  
  <strong>Υπεύθυνος Προστασίας Δεδομένων</strong></p>
  <p>
  
  Σε περίπτωση που έχετε ερωτήσεις σχετικά με την προστασία των δεδομένων σας και τα δικαιώματά σας, μπορείτε να στείλετε email στο info@apokoronas.gov.gr ή να απευθυνθείτε εγγράφως στην ταχυδρομική διεύθυνση: Οικισμός Βρύσες, Αποκορώνου Χανίων, Χανιά
  
  και θα απαντήσουμε σε αυτές το συντομότερο δυνατόν και όχι αργότερα από ένα μήνα.
  </p>
  <p>
  
  <strong>Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα</strong></p>
  <p>
  
  Έχετε δικαίωμα να υποβάλλετε καταγγελία στην Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα (www.dpa.gr ), η οποία είναι η αρμόδια εποπτική αρχή για την προστασία των θεμελιωδών δικαιωμάτων και ελευθεριών των φυσικών προσώπων έναντι της επεξεργασίας των προσωπικών τους δεδομένων του, εφόσον θεωρείτε ότι προσβάλλονται τα δικαιώματά σας με οποιοδήποτε τρόπο.
  
  Σας παροτρύνουμε να δείτε την Πολιτική για την Ιδιωτικότητα και την Προστασία των Προσωπικών Δεδομένων του Ιδρύματος στον σύνδεσμο Πολιτική Ιδιωτικότητας και προστασίας δεδομένων</p></div>
  </div>
  
  )};
  
  function PolEn() {
   
    return(
    
      <div><div className={classes.pHead}><div className={classes.pTitle}><h1>Privacy Policy</h1></div></div><div className={classes.pContent}><p>
      What personal data of mine is collected and how?<br />
      The personal data collected and processed by the Municipality of Apokoronou are only those that are necessary for the specific and clearly defined purpose and the specific legal basis.
  </p>
  <p>
      In this context, the processing that takes place concerns the personal data you provide to the Municipality of Apokorono in real interactive time, when you use our services, our official websites, for example by registering, such as:
  </p>
  <p>
      Name<br />
      Last name<br />
      E-mail<br />
      In those cases where the processing is based on obtaining consent, the Municipality of Apokoronos follows the procedures provided by the Law for obtaining this consent.
  </p>
  <p>
      For what purposes is the processing done and what is its legal basis?
  </p>
  <p>
      Personal data is collected in accordance with the GDPR and applicable legislation, either at the start of your relationship with the Organization or later and is subject to processing on a legal basis:
  </p>
  <p>
      Your consent, when required The execution of a contract between us The fulfillment of our legal obligations The safeguarding of a vital interest The fulfillment of a duty for the public interest The safeguarding of our legal interest or that of a third party Apokorono Municipality may process your personal data for the following purposes by legal basis:
  </p>
  <p>
      With your consent<br />
      Transfer of personal data to third parties
  </p>
  <p>
      Send updates<br />
      To fulfill the contractual obligation in case of entering into a contract with the Municipality of Apokoronou or during the pre-contractual procedure<br />
      For communication during the pre-contractual process or during the execution of the contract<br />
      To fulfill our legal obligations<br />
      To fulfill our obligations in accordance with the applicable legislation towards public authorities and bodies (Supervisory, Independent, Police, Judicial).<br />
      To safeguard your or a third party's vital interest<br />
      In the event that your life or the life of a third party is at risk<br />
      For reasons of our legitimate interest, as:<br />
      To develop and improve our services through your activities and interests. To handle your complaints. For the protection and security of IT systems.
  </p>
  <p>
      Who are the recipients of my personal data?
  </p>
  <p>
      The staff of the Municipality of Apokoronos have access to your personal data, in the context of the performance of the tasks assigned to them by the Municipality of Apokoronos as data controller. The Municipality of Apokoronou is obliged or entitled to share your personal data with various third party recipients such as: Public bodies Independent authorities under the condition of observing confidentiality and the duty of confidentiality and confidentiality in any case.
  </p>
  <p>
      How long is my data kept?
  </p>
  <p>
      The Municipality of Apokoronos keeps your personal data only for the period required for the purposes of the processing. However, it must keep the personal data for a period of time determined by the applicable legal and regulatory framework.
  </p>
  <p>
      What are cookies and why does Apokorono Municipality collect them?
  </p>
  <p>
      To ensure that our website works properly, a small piece of data known as a cookie may sometimes be stored on your computer or mobile device when you visit our website. A cookie is a text file that is stored by a web server on a computer or mobile device. The content of a cookie can only be retrieved or read by the server that creates the cookie. The text in a cookie often consists of identifiers, site names, and certain numbers and characters. Cookies are unique to the browsers or mobile apps you use and allow websites to store data such as your preferences.
  </p>
  <p>
      How is my data protected?
  </p>
  <p>
      At Apokorono Municipality we work every day to ensure that the personal data we receive: Is processed lawfully and legitimately in a transparent manner in relation to the data subject. They are collected exclusively for specific and legal purposes. They are sufficient, relevant to the purpose for which we collect them and limited to what is necessary. They are accurate and up to date. They are kept exclusively within the specified time frame and no longer. They are processed in such a way as to ensure their necessary protection.
  </p>
  <p>
      What are my rights?
  </p>
  <p>
      The Municipality of Apokoronou does not process in an automated way and does not create a profile for any natural person whose personal data it maintains. The data subject has the following rights: The right to access
  </p>
  <p>
      You can at any time be informed by us about your personal data that we hold, and have access to it. The right to data correction
  </p>
  <p>
      You have the option to contact us to correct data that is inaccurate or incomplete. The "right to be forgotten"
  </p>
  <p>
      As long as we are not required by law to retain the data we hold relating to you, you can ask us to delete it. The right to data portability
  </p>
  <p>
      You can ask us to transfer your data to another public or private body. The right to object and to restrict processing In case you disagree with the way we process your personal data, you can request the interruption or restriction of processing. The right withdrawal of consent
  </p>
  <p>
      You have the right to withdraw your consent to the processing of your data at any time. The Municipality of Apokoronou will make every effort to respond to the request you submit without delay and in any case within a month of receiving it. This deadline is extended for another two (2) months, if necessary considering the complexity of the request and the number of requests. The Municipality of Apokoronou will inform you of the said extension within a month of receiving the request, as well as the reasons for the delay. If you have made the request by electronic means, the update will be provided, if possible, by electronic means, unless you request otherwise. If the Municipality of Apokoronos satisfies your request a) to limit the processing of your data or b) to refuse to process your data or c) to delete your data from the organization's records and if these are necessary for the preparation or continuation and execution contract, then this automatically implies either the cancellation by you of the corresponding contract or the inability to process your relevant request.
  </p>
  <p>
      Withdrawal of consent
  </p>
  <p>
      You have the right to withdraw your consent at any time. The withdrawal of your consent does not affect the legality of the processing based on it and carried out before its withdrawal.
  </p>
  <p>
      Cookies
  </p>
  <p>
      To ensure that our website and mobile app work properly, we may sometimes place a small piece of data known as a cookie on your computer or mobile device. A cookie is a text file that is stored by a web server on a computer or mobile device. The content of a cookie can only be retrieved or read by the server that creates the cookie. The text in a cookie often consists of identifiers, site names, and certain numbers and characters. Cookies are unique to the browsers or mobile apps you use and allow websites to store data such as your preferences.
  </p>
  <p>
      Data Protection Officer
  </p>
  <p>
      In case you have questions about the protection of your data and your rights, you can send an email to info@apokoronas.gov.gr or write to the postal address: Oikismos Vryses, Apokoronou Chania, Chania and we will answer them on as soon as possible and no later than one month.
  </p>
  <p>
      Personal Data Protection Authority
  </p>
  <p>
      You have the right to file a complaint with the Personal Data Protection Authority (www.dpa.gr), which is the competent supervisory authority for the protection of the fundamental rights and freedoms of natural persons against the processing of their personal data, if you consider that they are being violated your rights in any way. We encourage you to view the Institution's Privacy and Data Protection Policy at the Privacy and Data Protection Policy link
  </p></div>
    </div>
    
    )};

  return (
    <div>
      {currentLanguageCode == 'el' &&
        <PolEl />   
      }
      {currentLanguageCode == 'en' &&
        <PolEn />   
      }
      

    </div>
  );
}

export default Pol;
